"use client";
import Image from "next/image";
import React from "react";

export default function CallToAction({ heading = "Not Sure What Applies To Your Company?" }: { heading?: string } = {}) {
  return (
    <section className="w-full bg-black  min-[1340px]:px-0 py-[40px] lg:py-[60px]">
      <div className="relative  overflow-hidden bg-[#1544EB]">
        <Image
          src="/corporate-secretary/ellipse1.svg"
          alt="Background Circle"
          height={323}
          width={323}
          className="absolute overflow-hidden -left-36 -top-[10rem] w-323[px] h-[323px]"
        />

        <Image
          src="/corporate-secretary/ellipse1.svg"
          alt="Background Circle"
          height={323}
          width={323}
          className="absolute -right-32 overflow-hidden -bottom-[10rem] w-323[px] h-[323px]"
        />
        <div className="relative overflow-hidden max-w-[1200px] mx-auto  px-8 sm:px-12 lg:px-16 py-10 lg:py-12 flex flex-col sm:flex-row items-center justify-between gap-6">
          {/* Text */}
          <div className="relative z-10 flex flex-col gap-2 max-w-[620px]">
            <h2 className="text-white font-inter font-bold text-[22px] sm:text-[26px] lg:text-[28px] leading-[130%]">
              {heading}
            </h2>
            <p className="text-white/80 font-inter font-normal text-[14px] sm:text-[15px] lg:text-[16px] leading-[160%]">
              We can help you understand what applies to your company.
            </p>
          </div>
          {/* Button */}
          <div className="relative z-10 shrink-0">
            <a
              href="https://calendly.com/d/cxy2-dy2-tqk/mutetaxes-consultation-call"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-white text-[#2D35E0] font-inter font-medium text-[15px] px-6 py-3 rounded-xl hover:bg-opacity-90 transition whitespace-nowrap"
            >
              Schedule a consultation
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
